import { Eye, UserPlus, XCircle, MoreVertical } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMediaCar } from "../../services/api";
import { useState, useRef, useEffect } from "react";

export default function OrderRow({ order, onView, onAssign, onCancel }) {
  const avatar = resolveMediaCar(order?.car?.image, defaultAvatar);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <tr>
      <td>{order?.order_type?.name || "-"}</td>

      {/* Statut */}
      <td>
        <span
          className={`statusBadge${order?.statut?.name === "Terminé" ? "Termine" : order?.statut?.name === "En attente" ? "Attente" : order?.statut?.name === "En cours" ? "Cours" : order?.statut?.name === "Annulé" ? "Annule" : ""}`}
        >
          {order?.statut?.name}
        </span>
      </td>

      {/* CLIENTS */}
      <td>
        {order?.customer?.user?.firstName} {order?.customer?.user?.lastName}
      </td>

      {/* Chauffeur */}
      <td>
        {order?.driver?.user
          ? `${order.driver.user.firstName} ${order.driver.user.lastName}`
          : "Non assigné"}
      </td>

      {/* Montant */}
      <td>
        <span className="roleBadge">{order?.amount || 0} CFA</span>
      </td>

      <td className="center">
        <div className="actionsMenu" ref={menuRef}>
          <button className="iconBtn" onClick={() => setOpen(!open)}>
            <MoreVertical size={18} />
          </button>

          {open && (
            <div className="dropdownActions">
              {/* Voir détails */}
              <button onClick={() => onView?.(order)}>
                <Eye size={16} /> Voir détails
              </button>
              {/* Assigner chauffeur */}
              {!order?.driver && order?.id_status === "S01" && (
                <button  onClick={() => onAssign(order)}
                  type="button"
                  className="iconBtn assignBtn"
                  title="Assigner un chauffeur">
                  <UserPlus size={18} /> Assigner un chauffeur
                </button>
              )}
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}
